export default __webpack_public_path__ + "static/media/Strawberry.4a3d2c41.svg";